import type { TeamTab, TeamAggregated } from '../types';

interface SummaryStatsProps {
  activeTab: TeamTab;
  aggregated: TeamAggregated | null;
}

export function SummaryStats({ activeTab, aggregated }: SummaryStatsProps) {
  if (!aggregated) {
    return (
      <div className="summary-stats">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="stat-card">
            <div className="stat-value">-</div>
            <div className="stat-label">Loading...</div>
          </div>
        ))}
      </div>
    );
  }

  if (activeTab === 'sales') {
    return (
      <div className="summary-stats">
        <div className="stat-card main-stat">
          <div className="stat-value">${(aggregated.totalEstimatesWonAmount || 0).toLocaleString()}</div>
          <div className="stat-label">Total Won Amount</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">
            <span className="won">{aggregated.totalEstimatesWon || 0}</span>
            {' / '}
            <span className="open">{aggregated.totalEstimatesOpen || 0}</span>
            {' / '}
            <span className="lost">{aggregated.totalEstimatesLost || 0}</span>
          </div>
          <div className="stat-label">Won / Open / Lost</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{aggregated.avgConversionRate || 0}%</div>
          <div className="stat-label">Team Conversion Rate</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">${(aggregated.avgTicket || 0).toLocaleString()}</div>
          <div className="stat-label">Average Ticket</div>
        </div>
      </div>
    );
  }

  if (activeTab === 'repair') {
    return (
      <div className="summary-stats">
        <div className="stat-card main-stat">
          <div className="stat-value">${(aggregated.totalEstimatesWonAmount || 0).toLocaleString()}</div>
          <div className="stat-label">Total Won Amount</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{aggregated.totalServiceCalls || 0}</div>
          <div className="stat-label">Total Service Calls</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">${(aggregated.totalServiceCallsRevenue || 0).toLocaleString()}</div>
          <div className="stat-label">Service Calls Revenue</div>
        </div>
        <div className="stat-card">
          <div className="stat-value callback-warning">{aggregated.totalCallbacks || 0}</div>
          <div className="stat-label">Total Callbacks</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{aggregated.avgConversionRate || 0}%</div>
          <div className="stat-label">Team Conversion Rate</div>
        </div>
      </div>
    );
  }

  // Installation
  return (
    <div className="summary-stats">
      <div className="stat-card main-stat">
        <div className="stat-value">{aggregated.totalInstallationJobs || 0}</div>
        <div className="stat-label">Total Installation Jobs</div>
      </div>
      <div className="stat-card">
        <div className="stat-value callback-warning">{aggregated.totalCallbacks || 0}</div>
        <div className="stat-label">Total Callbacks</div>
      </div>
      <div className="stat-card">
        <div className="stat-value failed-warning">{aggregated.totalFailedInspections || 0}</div>
        <div className="stat-label">Failed Inspections</div>
      </div>
    </div>
  );
}
